// 出入证
const OutInRoutes = [
  {
    path: '/outInAuth',
    name: 'outInAuth',
    meta: { title: '' },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/OutInMark/Auth.vue'),
  },
  {
    path: '/outInList',
    name: 'outInList',
    meta: { title: '出入证', keepAlive: true },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/OutInMark/List.vue'),
  },
  {
    path: '/outInDetail',
    name: 'outInDetail',
    meta: { title: '' },
    component: () =>
      import(/* webpackChunkName: "agreement" */ '../views/OutInMark/Detail.vue'),
  },

];
export default OutInRoutes;
